<template>
  <v-container class="pa-0">
    <div class="pa-2 grey lighten-3" style="max-height: 56px">
      <v-text-field
        color="red"
        label="search shops"
        prepend-inner-icon="mdi-magnify"
        solo
        flat
        outlined
        dense
        clearable
        v-model.lazy="params.search"
        @input="searchShops"
      >
        >
      </v-text-field>
    </div>
    <v-skeleton-loader
      class="pt-16"
      v-if="!isLoaded"
      type="list-item-two-line, divider, list-item-two-line, divider,list-item-two-line,divider,list-item-two-line,divider"
    ></v-skeleton-loader>

    <v-container
      class="pt-16 mt-16"
      v-if="shops.length == 0 && isLoaded && !isLoading"
    >
      <div align="center">
        <v-img src="../assets/inbox.png" width="128px"></v-img>
        <h5 class="pt-3 subtitle-2 grey--text text--darken-2">
          Sorry, No data found
        </h5>
      </div>
    </v-container>

    <v-container v-if="isLoaded">
      <v-row
        v-for="(shop, index) in shops"
        :key="index"
        v-ripple
        @click="handleOpenDialog(shop.id)"
      >
        <v-col cols="12 text-left">
          <h4 class="subtitle-1">{{ shop.name }}</h4>
          <h5 class="caption grey--text text--darken-2">
            <v-icon small>mdi-map-marker</v-icon>
            {{ shop.area.name }}, {{ shop.area.village.taluk.district.name }}
          </h5>
          
        </v-col>
      </v-row>
    </v-container>
    <div v-if="isLoading" class="text-center pt-2 pb-2">
      <v-progress-circular
        :width="3"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <Shop :dialog.sync="shopDialog" :id="current_shop" />
    <AddShop :dialog.sync="addShopDialog" />
    <v-snackbar v-model="snackbar" timeout="2500" color="error"
      >{{ snackbar_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import Shop from "./modals/_shop";
import AddShop from "./modals/_addShop";
export default {
  components: {
    Shop,
    AddShop,
  },
  data() {
    return {
      shop: this.$route.params.name,
      isOpenDialog: false,
      shopDialog: false,
      addShopDialog: false,
      snackbar: false,
      snackbar_message: "Internal Server Error",
      shops: [],
      dialog: false,
      isLoading: false,
      isLoaded: false,
      isBottom: false,
      total_count: 0,
      search: "",
      params: {
        search: "",
        page_size: 1000,
        database_offset: 0,
      },
      current_shop: null,
    };
  },

  created() {
    window.addEventListener("scroll", () => {
      this.isBottom = this.bottomVisible();
    });
    this.fetchShops();
  },
  mounted() {
    this.$root.$on("addShop", this.handleOpenDialogAS);
  },
  watch: {
    isBottom(isBottom) {
      if (
        isBottom &&
        this.params.database_offset + this.params.page_size < this.total_count
      ) {
        this.isLoading = true;
        this.params.database_offset += this.params.page_size;
        this.fetchShops();
      }
    },
  },
  methods: {
    fetchShops() {
      this.$api.getShops(this.params).then(
        (response) => {
          this.shops.push(...response.data.shops);
          this.total_count = response.data.count;
          this.isLoading = false;
          this.isLoaded = true;
        },
        () => {
          this.isLoading = false;
          this.isLoaded = true;
          this.snackbar = true;
        }
      );
    },
    searchShops() {
      if (!this.isLoaded) return;
      if (
        this.params.search === "" ||
        this.params.search === null ||
        (this.params.search !== null && this.params.search.length > 2)
      ) {
        this.isLoaded = false;
        this.shops = [];
        this.params.page_size = 10;
        this.params.database_offset = 0;
        this.fetchShops();
      }
    },
    handleOpenDialog(shop) {
      this.current_shop = shop;
      this.shopDialog = true;
    },
    handleOpenDialogAS() {
      this.addShopDialog = true;
    },
    closeDialog() {
      this.isOpenDialog = false;
      this.$router.go("-1");
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
  },
  beforeUnmount() {
    window.removeEventListener("scroll");
  },
};
</script>
<style scoped>
.row {
  border-bottom: solid 1px #f1f1f1;
}
.v-text-field--outlined >>> fieldset {
  border: solid 1px rgba(0, 0, 0, 0.15);
}
</style>
